import ApiService from "./ApiService";

class CalendarService {
  static async getPropertySchedule({ propertyId, dateFrom = '', dateSelected = '', gmt = 'GMT-3', host }) {
    let composedURL = `/api3/schedule/event/schedule_visit?property_id=${propertyId}&date_from=${dateFrom}&date_selected=${dateSelected}&time_zone=${gmt}`

    const response = await ApiService.get(composedURL, {}, host);
   
    return response
  }

  static async confirmVisit({ host, ...payload }) {
    const composedURL = '/api3/schedule/event/schedule_visit'
    const response = await ApiService.post(composedURL, payload, null, host);
   
    return response
  }

  static async getVisitData({ visitId, host }) {
    const composedURL = `/api3/schedule/visit_info/${visitId}`
    const response = await ApiService.get(composedURL, {}, host);
   
    return response
  }

  static async cancelVisit({ host, ...payload }) {
    const composedURL = '/api3/schedule/event/schedule_visit'
    const response = await ApiService.delete(composedURL, payload, null, host);
   
    return response
  }

  static async getContactInfo({ host, propertyId, contactId }) {
    let composedURL = `/api3/booking/contact_info/?identifier=${propertyId}`

    if (contactId) {
      composedURL += `&contact_id=${contactId}`
    }

    const response = await ApiService.get(composedURL, {}, host);
   
    return response
  }
}

export default CalendarService;
